import React from 'react'
import styled from 'styled-components'
import { Field, reduxForm, SubmissionError, change, reset } from 'redux-form'
import { connect } from 'react-redux'

import { fetchCurrentUserSilent } from '../../actions/authActions'
import {
  verifySMSCode,
  verifyPhoneNumber,
} from '../../actions/phoneNumberActions'

import { Label, InputGroup, renderTextInput, renderError, Hint } from '../form'

import Button from '../display/Button'
import Spinner from '../display/Spinner'
import Overlay from '../display/Overlay'

const Wrapper = styled.div`
  position: relative;
  margin: 15px 0;
  padding: 30px;
  background-color: ${({ theme }) => theme.colors.grey};
`

const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const InputFlexButtons = styled.div`
  display: flex;
  flex: 1;
  margin: 8px -8px;

  button {
    flex: 1;
    margin: 0 8px;
  }
`

const normalizeCode = (value) => {
  if (!value) return value
  const onlyNums = value.replace(/[^\d]/g, '')
  return onlyNums.slice(0, 4)
}

class PhoneVerification extends React.Component {
  handleResend = () => {
    const { dispatch, phoneNumber } = this.props

    // Clear any Error
    dispatch(reset('PhoneVerification'))

    dispatch(verifyPhoneNumber(phoneNumber))
  }

  handleKeyPressEnter = (e) => {
    const { handleSubmit } = this.props
    if (e.key === 'Enter') {
      e.preventDefault()
      handleSubmit()
    }
  }

  render() {
    const { auth, handleSubmit, roundedInputs } = this.props
    return (
      <Wrapper>
        <InputGroup noMargin>
          <div style={{ marginBottom: 30 }}>
            <Hint>
              We’ve sent you a verification code via SMS. Enter it here to
              verify your mobile number.
            </Hint>
          </div>
          <FlexWrapper>
            <Label>
              Verification code
              <Field
                name="code"
                component={renderTextInput}
                placeholder="----"
                normalize={normalizeCode}
                onKeyPress={this.handleKeyPressEnter}
                rounded={roundedInputs}
              />
            </Label>
            <InputFlexButtons>
              <Button
                type="button"
                onClick={handleSubmit}
                rounded={roundedInputs}
                uppercase={false}
              >
                Verify
              </Button>
              <Button
                type="button"
                onClick={this.handleResend}
                rounded={roundedInputs}
                uppercase={false}
                ghost
              >
                Resend
              </Button>
            </InputFlexButtons>
          </FlexWrapper>
          <Field name="code" component={renderError} />
        </InputGroup>

        {(auth.verifyingSMSCode || auth.verifyingPhoneNumber) && (
          <Overlay>
            <Spinner />
          </Overlay>
        )}
      </Wrapper>
    )
  }
}

const PhoneVerificationForm = reduxForm({
  form: 'PhoneVerification',
  // validate,
})(PhoneVerification)

// mapStateToProps
// mapDispatchToProps
export default connect(
  ({ auth, ...state }) => ({
    auth,
    state,
  }),
  (dispatch, props) => ({
    onSubmit: (formValues) =>
      dispatch(
        verifySMSCode({ phone_number: props.phoneNumber, ...formValues })
      )
        .then(() => {
          dispatch(fetchCurrentUserSilent())
          dispatch(change('ListingYourProfile', 'phone_number_verified', true))
        })
        .catch(() => {
          throw new SubmissionError({
            code: 'Invalid SMS verification code.',
          })
        }),
  })
)(PhoneVerificationForm)
